import { render } from "./register-stepper.vue?vue&type=template&id=5e67e20b&scoped=true&ts=true"
import script from "./register-stepper.vue?vue&type=script&lang=ts"
export * from "./register-stepper.vue?vue&type=script&lang=ts"

import "./register-stepper.vue?vue&type=style&index=0&id=5e67e20b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e67e20b"]])

export default __exports__